import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wordCounter'
})
export class WordCounterPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value ? value.length : 0;
  }
}
